var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHq = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    fill: "none",
    viewBox: "0 0 20 19",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7E869E",
    d: "m10.193 14.09-.365-.703zm-.63 0-.365.702zm5.065-6.97c0 1.699-.865 3.1-1.944 4.188s-2.304 1.793-2.856 2.079l.73 1.405c.622-.322 2.009-1.117 3.25-2.37 1.241-1.25 2.403-3.03 2.403-5.302zm-4.75-4.75a4.75 4.75 0 0 1 4.75 4.75h1.583A6.333 6.333 0 0 0 9.878.786zm-4.75 4.75a4.75 4.75 0 0 1 4.75-4.75V.786A6.333 6.333 0 0 0 3.544 7.12zm4.799 6.267c-.551-.286-1.778-.991-2.856-2.079-1.079-1.088-1.943-2.49-1.943-4.188H3.544c0 2.272 1.162 4.051 2.403 5.303s2.628 2.047 3.251 2.37zm-.099 0a.1.1 0 0 1 .05-.011.1.1 0 0 1 .049.01l-.729 1.406c.429.223.93.223 1.36 0zm1.633-6.267c0 .874-.709 1.583-1.583 1.583v1.584a3.167 3.167 0 0 0 3.166-3.167zM9.878 5.536c.874 0 1.583.71 1.583 1.584h1.583a3.167 3.167 0 0 0-3.166-3.167zM8.294 7.12c0-.875.71-1.584 1.584-1.584V3.953A3.167 3.167 0 0 0 6.71 7.12zm1.584 1.583A1.583 1.583 0 0 1 8.294 7.12H6.711a3.167 3.167 0 0 0 3.167 3.167z"
  })));
};
export default SvgHq;